import React, { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { NavLink } from 'react-router-dom';

import axios, { AxiosResponse } from 'axios';

import { Breadcrumb } from '@shared/components/bootstrap';

import { PageHeader } from '@admin/components/helpers/page_header';
import { Spinner } from '@admin/components/spinner';
import { useAxiosRequest } from '@admin/hooks/use_axios_request';
import { useTitle } from '@admin/hooks/use_title';

import { TransferPoolForm } from './form';

type Barcode = {
  value: string;
};

type Image = {
  id: number;
  state: string;
  source: string;
};

type Item = {
  id: number;
  hero: number;
  images: Image[];
};

type Pallet = {
  id: number;
  state: string;
  barcode: Barcode;
  items: Item[];
};

type Warehouse = {
  id: number;
  name: string;
};

type TransferPool = {
  id: number;
  pallets: Pallet[];
  origin: Warehouse;
  destination: Warehouse;
};

const useTransferPoolRequest = (id: string | number) => {
  const [request, setRequest] = useState<Promise<AxiosResponse<TransferPool>> | undefined>(undefined);
  useEffect(() => {
    setRequest(axios.get<TransferPool>(`/transferpools/${id}.json`));
  }, [id]);

  return useAxiosRequest(request);
};

export const TransferPoolEdit: FC = () => {
  useTitle('Edit Transfer Pool');
  const { id } = useParams<{ id: string }>();
  const { response } = useTransferPoolRequest(id);
  const transferpool = response?.data;

  if (!transferpool) return <Spinner />;

  return (
    <>
      <PageHeader>
        <Breadcrumb>
          <Breadcrumb.Item>
            <NavLink to="/transferpools">Transfer Pool</NavLink>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <NavLink to={`/transferpools/${id}`}>
              {transferpool.origin.name} to {transferpool.destination.name}
            </NavLink>
          </Breadcrumb.Item>
          <Breadcrumb.Item active>Edit</Breadcrumb.Item>
        </Breadcrumb>
      </PageHeader>
      <TransferPoolForm transferpool={transferpool} />
    </>
  );
};
